export {ResetPassword as Page};

import {useState, useContext} from 'preact/hooks';
import {sendPasswordResetEmail} from 'firebase/auth';
import {auth} from '../../includes/firebase';
import {Helmet} from "react-helmet-async";
import messages from "../../messages/messages.js";
import {NotificationContext} from '../../components/NotificationContext.jsx';
import {RingSpinner} from '../../components/Spinner.jsx';

function ResetPassword() {

    const {addNotification} = useContext(NotificationContext);

    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false);

    const triggerResetEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        await sendPasswordResetEmail(auth, email, {url: "https://" + messages["DOMAIN"]}).then(() => {
            addNotification('Check your email to reset your password', 'success');
        }).catch((error) => {
            addNotification(error.message, 'error');
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | Forgot Password</title>
                <meta name="description" content="Forgot your account password"/>
            </Helmet>

            <div className="flex justify-center">
                <div className="w-full border border-border/60 bg-zinc-800 rounded-lg shadow-sm md:mt-0 sm:max-w-md xl:p-0">
                    <form onSubmit={triggerResetEmail} className="p-6 space-y-4 md:space-y-6 sm:p-8">

                        <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl">
                            Forgot password?
                        </h1>
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-white">Your
                                email</label>
                            <input type="email" name="email" id="email"
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                                   placeholder="name@company.com" required=""/>
                        </div>
                        <button type="submit"
                                className="w-full cursor-pointer text-white border border-white hover:bg-white hover:text-black font-medium rounded-lg text-sm px-5 py-2.5 text-center">Reset
                            password {loading && <RingSpinner/>}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
}
